import React from 'react'
import { connect } from 'react-redux'
import EventsActions from '../../Redux/EventsRedux'

class UpdateEventsPriority extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      event_name: this.props.detail.name,
      event_id: this.props.detail.event_id,
      form: {
        is_popular: true,
        priority: props.detail.priority
      }
    }
  }

  _inputChange = (event, field) => {
    const target = event.target
    let value = target.type === 'checkbox' ? target.checked : target.value
    let form = { ...this.state.form }
    form[field] = value
    this.setState({ form })
  }

  _submit = (event) => {
    event.preventDefault()
    let form = { ...this.state.form }
    const data = {
      event_id: this.state.event_id,
      form
    }
    this.props.setPriority(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <div className='section' style={{ width: '40vw' }} >
        <div>
          <div className='title-block'>
            <h4 className='title mr-auto'>Update Events Priority</h4>
          </div>
          <form onSubmit={(event) => this._submit(event)} >
            <div className='form-group row'>
              <div className='col-3'>
                <label className='control-label'>Event</label>
              </div>
              <div className='col-9'>
                <input className='form-control' disabled value={this.state.event_name} />
              </div>
            </div>
            <div className='form-group row'>
              <div className='col-3'>
                <label className='control-label'>Set Priority</label>
              </div>
              <div className='col-9'>
                <input
                  type='number'
                  min='1'
                  className='form-control'
                  value={this.state.form.priority}
                  onChange={(event) => this._inputChange(event, 'priority')}
                />
              </div>
            </div>
            <div className='form-group text-right'>
              <button type='button' className='btn btn-secondary' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary ml-2'>Save</button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({
  setPriority: (data) => dispatch(EventsActions.setPopularEventRequest(data))
})

export default connect(stateToProps, dispatchToProps)(UpdateEventsPriority)



// WEBPACK FOOTER //
// ./src/Containers/Events/UpdateEventsPriority.js